<template>
  <div class="chartsRing_charts">
    <div class="charts" :id="idName"></div>
    <div class="name">{{ livestockName }}</div>
  </div>
</template>
<script>
import * as echarts from 'echarts';
import { mapColors } from '@/utils/config';
export default {
  data() {
    return {
      myChart: null,
      colors: mapColors,
      clickData: [],
      click_status: false,
      option: null
    };
  },
  props: ['idName', 'chartsRingObj', 'livestockName', 'legendList'],
  methods: {
    initMap() {
      if (this.myChart) {
        this.myChart.dispose();
      }
      this.myChart = echarts.init(document.getElementById(this.idName));
      let m2R2Data = this.chartsRingObj.materCountList.map((item, index) => {
        return {
          value: item.materNum,
          legendname: item.materName,
          itemStyle: {
            color: this.colors[this.legendList.findIndex((legend) => item.materName === legend.name)]
          }
        };
      });

      this.clickData = m2R2Data;
      this.fnOption(this.clickData);
      this.myChart.setOption(this.option, true);
      this.myChart.on('click', (param) => {
        this.clickData = [];
        this.click_status = !this.click_status;
        if (this.click_status) {
          this.clickData.push(param.data);
        } else {
          this.clickData = m2R2Data;
        }
      });
    },
    fnOption(m2R2Data) {
      this.option = {
        title: [
          {
            text: this.chartsRingObj.livestockNum,
            textStyle: {
              fontSize: 18,
              color: 'white'
            },
            // subtext: 12312+'个',
            // subtextStyle: {
            //   fontSize: 20,
            //   color: 'black',
            //   align: 'center'
            // },
            // textAlign:"center",
            x: 'center',
            y: 'center'
          }
        ],
        color: ['#32716E'],
        tooltip: {
          trigger: 'item',
          formatter: function(parms) {
            var str =
              parms.seriesName +
              '</br>' +
              parms.marker +
              '' +
              parms.data.legendname +
              '</br>' +
              '数量：' +
              parms.data.value +
              '</br>';
            // "占比："+ parms.percent+"%";
            return str;
          }
        },
        series: [
          {
            name: this.livestockName,
            // name: '123',
            type: 'pie',
            center: ['50%', '50%'],
            radius: ['72%', '92%'],
            clockwise: true, //饼图的扇区是否是顺时针排布
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false
              }
            },
            labelLine: {
              normal: {
                length: 5,
                length2: 3,
                smooth: true
              }
            },
            data: m2R2Data
          }
        ]
      };
    }
  },
  watch: {
    clickData(val) {
      this.clickData = val;
      this.myChart.clear();
      this.fnOption(this.clickData);
      this.myChart.setOption(this.option, true);
    }
  }
};
</script>

<style lang="scss" scoped>
.chartsRing_charts {
  // width: 100%;
  // height: 100%;
  text-align: center;

  .charts {
    width: 120px;
    height: 120px;
    display: inline-block;
  }

  .name {
    font-size: 14px;
    text-align: center;
    color: white;
    padding: 5% 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/SmartLivestock/statistics/component/chartsRingModule.vue